(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('SeekingGenderSearch', SeekingGenderSearch);

    SeekingGenderSearch.$inject = ['$resource'];

    function SeekingGenderSearch($resource) {
        var resourceUrl =  'api/_search/seeking-genders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
